"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagIcon = exports.StyledTagIcon = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var index_1 = __importDefault(require("../../FontAwesomeIcon/index"));
exports.StyledTagIcon = styled_components_1.default(index_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 7px;\n"], ["\n  margin-left: 7px;\n"])));
var TagIcon = function (_a) {
    var props = __rest(_a, []);
    return (react_1.default.createElement(exports.StyledTagIcon, __assign({}, props, { "aria-hidden": "true" })));
};
exports.TagIcon = TagIcon;
exports.default = exports.TagIcon;
var templateObject_1;
//# sourceMappingURL=index.js.map